import * as React from 'react';

import { Entry } from 'contentful';
import { Page } from 'src/api/contentful/contentTypes.public';
import { componentKey } from 'src/utils/EntryUtil';
import { SectionDocument } from './SectionDocument';

type HtmlElementProps = React.HTMLProps<HTMLElement>;
export type PageWrapperProps = Pick<HtmlElementProps, Exclude<keyof HtmlElementProps, 'ref'>> & {
  entry: Entry<Page>;
};

export const PageWrapper: React.FC<PageWrapperProps> = ({ entry, ...htmlProps }) => {
  const components = entry && entry.fields && entry.fields.components || [];
  if (!components || !components.length) { return null; }
  return (
    <section {...htmlProps}>
      {components.map((document, idx) => document && <SectionDocument key={componentKey(document, idx)} entry={document} />)}
    </section>
  );
};
